module.exports = __webpack_public_path__ + "img/why-go-wordpress.8f9b5873.webp";